export default __webpack_public_path__ + "static/media/Social.ffa2b2bf.png";